import React, { useEffect } from 'react';
import styled from 'styled-components';
import * as Icons from '../../Buttons/IconButton/Icons';
import { T } from '../Utils';
import { loadStateSession } from '../../../FlyfishComponents/flyfishutils/utils';

interface Props {
	suggestions?: any;
	data?: string;
	multiIntent?: boolean;
	handleSubmit?: Function;
	voiceResponse: boolean;
	configData?: any;
	channel?: string;
	timeStamp?: string;
	addUserResponse?: Function;
	shouldDisableActions?: boolean;
}
const RelatedItems = styled.button`
	position: relative;
	border-top: 1px solid
		${(props: any) => {
			return props.foreground + '4d';
		}};
	&:hover:before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: any) => {
			return props.foreground + '1a';
		}};
	}
	&:focus-visible:before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: any) => {
			return props.foreground + '33';
		}};
	}
	&:active:before {
		position: absolute;
		inset: 0;
		content: '';
		left: 0;
		top: 0;
		background-color: ${(props: any) => {
			return props.foreground + '33';
		}};
	}
`;
const styleVars = getComputedStyle(document.querySelector(':root'));

const RelatedOptions = (props: Props) => {
	const {
		suggestions,
		data,
		multiIntent,
		handleSubmit,
		voiceResponse,
		addUserResponse,
	} = props;
	let background =
		styleVars.getPropertyValue('--srvMsgBackground') || '#383ff6';
	let foreground = styleVars.getPropertyValue('--srvMsgColor') || '#ffffff';

	useEffect(() => {
		const keyDownHandler = (event) => {
			if (
				event.key === 'Enter' &&
				props.channel === 'whatsapp' &&
				!props.shouldDisableActions
			) {
				event.preventDefault();
				const userResponse = loadStateSession('userResp');
				let deliverQuicklinks = suggestions.filter(
					(eachDisamb: any, index: number) => index === Number(userResponse) - 1
				);
				if (
					deliverQuicklinks &&
					deliverQuicklinks[0] &&
					!props.shouldDisableActions
				) {
					addUserResponse(userResponse.toString(), Date.now());
					handleSubmit(
						deliverQuicklinks[0].actionText.toString() ||
							deliverQuicklinks[0].displayText.toString(),
						{},
						{ isHidden: true }
					);
				}
			}
		};
		document.addEventListener('keydown', keyDownHandler);
		return () => {
			document.removeEventListener('keydown', keyDownHandler);
		};
	}, [suggestions, !props.shouldDisableActions]);

	function returnExtraData(extraDisambInformation) {
		try {
			let titleText;
			if (Object.keys(extraDisambInformation)) {
				titleText = `
                  Recognised Information
                  Entity: ${extraDisambInformation.matchedEntity}
                  Intent: ${extraDisambInformation.matchedIntent}
                  Question: ${extraDisambInformation.matchedQn}
                  Entity Heirarchy: ${extraDisambInformation.entityHeirarchy}
                  Semantics Identified: ${extraDisambInformation.semantics}
                  Variations Matched: ${extraDisambInformation.variationMatched}
                  Intent Score: ${extraDisambInformation.intentScore}
                  Intent Not Match: ${extraDisambInformation.intentNotMatch}
                  Reverse Intent Score: ${extraDisambInformation.reverseIntentScore}
                  Reverse Intent Not Match: ${extraDisambInformation.reverseIntentNotMatch}
                  Semantic Sequence: ${extraDisambInformation.semanticsSequence}
                  ContextEnable: ${extraDisambInformation.entityInContext}
              `;
			}
			return titleText;
		} catch (e) {
			return '';
		}
	}

	return props.channel === 'whatsapp' ? (
		<div className='sf-whatsapp-quicklink-wrapper'>
			<div className='whatsapp-quicklink-disamb-wrapper'>
				<p
					className='whatsApp-text'
					dangerouslySetInnerHTML={{
						__html: data,
					}}
				/>
				{suggestions.map((eachDisamb, index) => {
					return (
						<p className='whatsapp-quicklinks whatsApp-text' key={index}>
							{index + 1}. {eachDisamb.displayText || eachDisamb.actionText}
						</p>
					);
				})}
				{suggestions && suggestions.length > 0 && (
					<p className='quicklinks-footer whatsApp-text'>
						<span>Tip:</span> To select an option,can enter its option number.
						E.g. 1
					</p>
				)}
			</div>
			<p className='whatsApp-time' style={{ margin: '0' }}>
				{props.timeStamp}
			</p>
		</div>
	) : (
		<div
			className={`sf-multiple-w mul-sel ${multiIntent ? 'multi-intent' : ''}`}>
			<div className='related-title' tabIndex={voiceResponse ? -1 : 0}>
				{data ? (
					<div
						className='body-text-1'
						dangerouslySetInnerHTML={{ __html: data }}
					/>
				) : (
					<span className='overline-text'>
						<T labelName='relatedQuestionsLabel' />
					</span>
				)}
			</div>
			<div
				style={{ width: 'auto' }}
				className='sf-multiple-result-w sf-multiple-select-result-w '>
				{suggestions.map((eachDisamb, i) => {
					return (
						<RelatedItems
							{...{ background: background, foreground: foreground }}
							className='related-item  clickable '
							key={i}
							style={{
								margin: '0',
								color: foreground,
								background: 'transparent',
								border: 'none',
								borderTop: `1px solid ${foreground}4d`,
								fontSize: '15px',
								fontFamily: 'var(--fontFamily)',
								textAlign: 'left',
							}}
							onClick={() =>
								handleSubmit(eachDisamb.displayText || eachDisamb.actionText)
							}
							title={
								props.configData && props.configData.isInsideAware
									? returnExtraData(eachDisamb)
									: ''
							}>
							<div className='arrow-icon'>
								<Icons.ThemedArrowRight fill={foreground} />
							</div>
							<span className=' disamb row-text'>{eachDisamb.displayText}</span>
						</RelatedItems>
					);
				})}
			</div>
		</div>
	);
};

export default RelatedOptions;
